<template>
    <v-dialog v-model="toOrderDialog" @keydown.esc="toOrderDialog = false" persistent :width="dialogWidth" retain-focus>
        <template v-slot:activator="{ on, toOrderAttrs }">
            <v-btn v-if="!mode || mode == 'button'" :color="groupSetting.mainColor" class="ml-n2" dark v-bind="toOrderAttrs" v-on="on" icon>
                <v-icon v-if="mode == 'button'">mdi-arrow-down-bold</v-icon>
            </v-btn>
            <v-btn v-if="mode == 'new'" :color="groupSetting.mainColor" style="float:right" small rounded dark v-bind="toOrderAttrs" v-on="on">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn v-if="mode == 'copy'" class="text-start" x-small icon v-bind="toOrderAttrs" v-on="on">
                <v-icon>mdi-content-copy</v-icon>
            </v-btn>
            <v-badge color="red" icon="mdi-exclamation-thick" overlap right v-if="mode == 'string' && isUrgent">
                <span v-bind="toOrderAttrs" v-on="on" class="finger caption font-weight-bold mr-2">{{ displayString }}</span>
            </v-badge>
            <span v-if="mode == 'string' && !isUrgent" v-bind="toOrderAttrs" v-on="on" class="finger caption font-weight-bold mr-2">{{ displayString }}</span>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">{{ dialogTitle }}</span>
            </v-card-title>
            <v-card-text>
                <v-row class="mt-n5">
                    <v-col cols="dialogCols">
                        <v-container>
                            <v-row class="mb-n6">
                                <v-col cols="12" md="6">
                                    <v-menu
                                            v-model="estimateDateDialog"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                    v-model="toOrderAttrs.estimateDate"
                                                    label="시작일"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="toOrderAttrs.estimateDate" @input="menu2 = false"></v-date-picker>
                                    </v-menu>
                                </v-col>

                                <v-col cols="12" md="6" class="mt-n7 mt-md-0">
                                    <v-menu
                                            v-model="dueDateDialog"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                    v-model="toOrderAttrs.dueDate"
                                                    label="납품예정일 *"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    required
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="toOrderAttrs.dueDate" @input="menu2 = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>

                            <v-row class="mb-n7">
                                <v-col cols="9" md="10">
                                    <v-autocomplete
                                            v-model="toOrderAttrs.clientId"
                                            :loading="toOrderClientLoading"
                                            :items="clientList"
                                            :search-input.sync="clientSearch"
                                            @change="toOrderClientLoading = false"
                                            @focusout="toOrderClientLoading = false"
                                            no-data-text="일치하는 거래처가 없습니다."
                                            auto-select-first
                                            clear-icon="mdi-format-clear"
                                            flat
                                            label="거래처를 검색해주세요."
                                            solo-inverted
                                            dense
                                            clearable
                                            ref="clientSearch"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="3" md="2">
                                    <AddClientButton></AddClientButton>
                                </v-col>
                            </v-row>

                            <v-row class="mb-n9">
                                <v-col cols="12" md="4">
                                    <v-select
                                            :items="productCategory"
                                            label="품목 *"
                                            item-value="text"
                                            v-model="toOrderAttrs.category"
                                            required
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md="8" class="mt-n7 mt-md-0">
                                    <v-text-field label="작업명 *" hint="작업명을 입력하세요." v-model="toOrderAttrs.title" required></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row class="mb-n9">
                                <v-col cols="12" class="mb-n7">
                                    <v-text-field label="납품장소1" hint="주소를 입력하세요." v-model="toOrderAttrs.address1"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-select
                                            :items="orderMethodList"
                                            label="납품방법1"
                                            item-value="text"
                                            v-model="toOrderAttrs.method1"
                                    ></v-select>
                                </v-col>
                                <v-col cols="8">
                                    <v-text-field label="연락처1" hint="연락처를 입력하세요." v-model="toOrderAttrs.phone1"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" class="mb-n7">
                                    <v-text-field label="납품장소2" hint="주소를 입력하세요." v-model="toOrderAttrs.address2"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select
                                            :items="orderMethodList"
                                            label="납품방법2"
                                            item-value="text"
                                            v-model="toOrderAttrs.method2"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md="8" class="mt-n7 mt-md-0">
                                    <v-text-field label="연락처2" hint="연락처를 입력하세요." v-model="toOrderAttrs.phone2"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row class="px-3 mb-0">
                                <v-textarea
                                        outlined
                                        label="비 고"
                                        v-model="toOrderAttrs.comment"
                                ></v-textarea>
                            </v-row>

                            <v-row v-if="position != 'edit'" class="px-3 mb-0">
                                <v-textarea
                                        outlined
                                        label="작업 참고사항"
                                        v-model="toOrderAttrs.commentForProcessing"
                                ></v-textarea>
                            </v-row>
                            <small>* 항목은 필수입니다.</small>
                        </v-container>
                    </v-col>
                    <v-col cols="12" md="6" class="mt-n15 mt-md-0" v-if="position != 'edit'">
                        <v-container>
                            <v-row class="mb-n5">
                                <v-col cols="12">
                                    <v-text-field label="상세 스펙" hint="상세 스펙을 입력하세요." v-model="toOrderAttrs.description"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row class="mb-n5">
                                <v-col cols="12" md="6">
                                    <v-text-field label="종이수량" hint="종이 수량을 입력하세요." v-model="toOrderAttrs.paperQuantity"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field label="낱개수량" hint="낱개 수량을 입력하세요." v-model="toOrderAttrs.quantity"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row class="mb-n9">
                                <v-col cols="12">
                                    <v-autocomplete
                                            v-model="toOrderAttrs.process1"
                                            :loading="process1Loading"
                                            :items="process1List"
                                            :search-input.sync="process1Search"
                                            no-data-text="일치하는 프로세스가 없습니다."
                                            auto-select-first
                                            clear-icon="mdi-format-clear"
                                            clearable
                                            flat
                                            label="프로세스1을 검색해주세요."
                                            solo-inverted
                                            @change="checkDuplicate1"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row v-if="toOrderAttrs.process1" class="mb-n9">
                                <v-col cols="12">
                                    <v-autocomplete
                                            v-model="toOrderAttrs.process2"
                                            :loading="process2Loading"
                                            :items="process2List"
                                            :search-input.sync="process2Search"
                                            no-data-text="일치하는 프로세스가 없습니다."
                                            auto-select-first
                                            clear-icon="mdi-format-clear"
                                            clearable
                                            flat
                                            label="프로세스2를 검색해주세요."
                                            solo-inverted
                                            @change="checkDuplicate2"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row v-if="toOrderAttrs.process2 && toOrderAttrs.process1" class="mb-n9">
                                <v-col cols="12">
                                    <v-autocomplete
                                            v-model="toOrderAttrs.process3"
                                            :loading="process3Loading"
                                            :items="process3List"
                                            :search-input.sync="process3Search"
                                            no-data-text="일치하는 프로세스가 없습니다."
                                            auto-select-first
                                            clear-icon="mdi-format-clear"
                                            clearable
                                            flat
                                            label="프로세스3을 검색해주세요."
                                            solo-inverted
                                            @change="checkDuplicate3"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row v-if="toOrderAttrs.process3 && toOrderAttrs.process2 && toOrderAttrs.process1" class="mb-n9">
                                <v-col cols="12">
                                    <v-autocomplete
                                            v-model="toOrderAttrs.process4"
                                            :loading="process4Loading"
                                            :items="process4List"
                                            :search-input.sync="process4Search"
                                            no-data-text="일치하는 프로세스가 없습니다."
                                            auto-select-first
                                            clear-icon="mdi-format-clear"
                                            clearable
                                            flat
                                            label="프로세스4를 검색해주세요."
                                            solo-inverted
                                            @change="checkDuplicate4"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row v-if="toOrderAttrs.process4 && toOrderAttrs.process3 && toOrderAttrs.process2 && toOrderAttrs.process1" class="mb-n9">
                                <v-col cols="12">
                                    <v-autocomplete
                                            v-model="toOrderAttrs.process5"
                                            :loading="process5Loading"
                                            :items="process5List"
                                            :search-input.sync="process5Search"
                                            no-data-text="일치하는 프로세스가 없습니다."
                                            auto-select-first
                                            clear-icon="mdi-format-clear"
                                            clearable
                                            flat
                                            label="프로세스5를 검색해주세요."
                                            solo-inverted
                                            @change="checkDuplicate5"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row v-if="toOrderAttrs.process5 && toOrderAttrs.process4 && toOrderAttrs.process3 && toOrderAttrs.process2 && toOrderAttrs.process1" class="mb-n9">
                                <v-col cols="12">
                                    <v-autocomplete
                                            v-model="toOrderAttrs.process6"
                                            :loading="process6Loading"
                                            :items="process6List"
                                            :search-input.sync="process6Search"
                                            no-data-text="일치하는 프로세스가 없습니다."
                                            auto-select-first
                                            clear-icon="mdi-format-clear"
                                            clearable
                                            flat
                                            label="프로세스6을 검색해주세요."
                                            solo-inverted
                                            @change="checkDuplicate6"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row v-if="toOrderAttrs.process6 && toOrderAttrs.process5 && toOrderAttrs.process4 && toOrderAttrs.process3 && toOrderAttrs.process2 && toOrderAttrs.process1" class="mb-n9">
                                <v-col cols="12">
                                    <v-autocomplete
                                            v-model="toOrderAttrs.process7"
                                            :loading="process7Loading"
                                            :items="process7List"
                                            :search-input.sync="process7Search"
                                            no-data-text="일치하는 프로세스가 없습니다."
                                            auto-select-first
                                            clear-icon="mdi-format-clear"
                                            clearable
                                            flat
                                            label="프로세스7을 검색해주세요."
                                            solo-inverted
                                            @change="checkDuplicate7"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" class="mb-n9">
                                    <v-text-field label="지류1" hint="지류1을 입력하세요." v-model="toOrderAttrs.paperType1"></v-text-field>
                                </v-col>
                                <v-col cols="12" class="mb-n9">
                                    <v-text-field label="지류2" hint="지류2를 입력하세요." v-model="toOrderAttrs.paperType2"></v-text-field>
                                </v-col>
                                <v-col cols="12" class="mb-n9">
                                    <v-text-field label="사이즈(절수)" hint="사이즈(절수)를 입력하세요." v-model="toOrderAttrs.paperSize"></v-text-field>
                                </v-col>
                                <v-col cols="6" class="mb-n9">
                                    <v-text-field label="인쇄" hint="인쇄 색상을 입력하세요." v-model="toOrderAttrs.color"></v-text-field>
                                </v-col>
                                <v-col cols="6" class="mb-n9">
                                    <v-text-field label="코팅" hint="코팅 방법을 입력하세요." v-model="toOrderAttrs.coating"></v-text-field>
                                </v-col>
                                <v-col cols="12" class="mb-n9">
                                    <v-text-field label="후가공" hint="후가공을 입력하세요." v-model="toOrderAttrs.postProcessing"></v-text-field>
                                </v-col>
                                <v-col cols="12" class="mb-n9">
                                    <v-text-field label="부자재" hint="부자재를 입력하세요." v-model="toOrderAttrs.subsidiary"></v-text-field>
                                </v-col>
                                <v-col cols="12" class="mb-n9">
                                    <v-text-field label="바닥지" hint="바닥지를 입력하세요." v-model="toOrderAttrs.floorPaper"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="4" sm="4" class="mb-n9">
                                    <v-checkbox v-model="toOrderAttrs.alarmCheck" :label="`미리알림`"></v-checkbox>
                                </v-col>
                                <v-col v-if="toOrderAttrs.alarmCheck" cols="8" sm="4" class="mb-n7">
                                    <v-select
                                            :items="alarmPeriodList"
                                            label="알림주기"
                                            item-value="value"
                                            v-model="toOrderAttrs.alarmPeriod"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="4" class="mb-n9">
                                    <v-checkbox v-model="toOrderAttrs.urgency" :label="`초지급`" style="float:right"></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>

                <v-row v-if="position != 'edit' && mode != 'copy'" class="ma-5 pa-2">
                    <v-col cols="12" v-if="!toOrderAttrs.draftImagePath" >
                        <v-file-input show-size label="시안 첨부" v-model="draftImage" accept="image/png, image/jpg, image/jpeg, image/gif" value ref="file" @change="handleFile"></v-file-input>
                    </v-col>
                    <v-col cols="12" v-if="toOrderAttrs.draftImagePath">
                        <v-container class="align-center">
                            <v-row>
                                <v-img v-bind:src="toOrderAttrs.draftImagePath" contain class="mx-auto finger" max-width="100%" @click="imageWidth = 100; draftImageDialog = true"></v-img>
                                <v-row justify="center">
                                    <v-dialog
                                            persistent
                                            scrollable
                                            v-model="draftImageDialog"
                                            max-width="100%"
                                            @keydown.esc="closeDraftImageDialog"
                                    >
                                        <v-card>
                                                <v-card-title class="headline">
                                                    시안 확인
                                                    <v-spacer></v-spacer>
                                                    <span style="float:right" class="mr-5">{{ imageWidth }}%</span>
                                                    <v-btn fab small color="primary" style="float:right" class="mr-3" @click="imagePlus">
                                                        <v-icon color="white">mdi-plus</v-icon>
                                                    </v-btn>
                                                    <v-btn fab small color="primary" style="float:right" @click="imageMinus">
                                                        <v-icon color="white">mdi-minus</v-icon>
                                                    </v-btn>
                                                </v-card-title>
                                            <v-card-text>
                                                <v-img :src="toOrderAttrs.draftImagePath" class="mx-auto" :width="imageWidth + '%'" max-width="300%"></v-img>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                        color="green darken-1"
                                                        text
                                                        @click="draftImageDialog = false, imageWidth = 100"
                                                >닫기</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-row>
                            </v-row>
                            <v-row>
                                <v-btn outlined color="primary" class="mt-3 ml-9" @click="deleteDraftImage(1)">시안 삭제</v-btn>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>

                <v-row v-if="position != 'edit' && mode != 'copy'" class="ma-5 pa-2">
                  <v-col cols="12" v-if="!toOrderAttrs.draftImagePath2" >
                    <v-file-input show-size label="시안 첨부" v-model="draftImage2" accept="image/png, image/jpg, image/jpeg, image/gif" value ref="file" @change="handleFile"></v-file-input>
                  </v-col>
                  <v-col cols="12" v-if="toOrderAttrs.draftImagePath2">
                    <v-container class="align-center">
                      <v-row>
                        <v-img v-bind:src="toOrderAttrs.draftImagePath2" contain class="mx-auto finger" max-width="100%" @click="imageWidth = 100; draftImageDialog2 = true"></v-img>
                        <v-row justify="center">
                          <v-dialog
                              persistent
                              scrollable
                              v-model="draftImageDialog2"
                              max-width="100%"
                              @keydown.esc="closeDraftImageDialog"
                          >
                            <v-card>
                              <v-card-title class="headline">
                                시안 확인
                                <v-spacer></v-spacer>
                                <span style="float:right" class="mr-5">{{ imageWidth }}%</span>
                                <v-btn fab small color="primary" style="float:right" class="mr-3" @click="imagePlus">
                                  <v-icon color="white">mdi-plus</v-icon>
                                </v-btn>
                                <v-btn fab small color="primary" style="float:right" @click="imageMinus">
                                  <v-icon color="white">mdi-minus</v-icon>
                                </v-btn>
                              </v-card-title>
                              <v-card-text>
                                <v-img :src="toOrderAttrs.draftImagePath2" class="mx-auto" :width="imageWidth + '%'" max-width="300%"></v-img>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="green darken-1"
                                    text
                                    @click="draftImageDialog2 = false, imageWidth = 100"
                                >닫기</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-row>
                      </v-row>
                      <v-row>
                        <v-btn outlined color="primary" class="mt-3 ml-9" @click="deleteDraftImage(2)">시안 삭제</v-btn>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>

                <v-row v-if="position != 'edit' && mode != 'copy'" class="ma-5 pa-2">
                  <v-col cols="12" v-if="!toOrderAttrs.draftImagePath3" >
                    <v-file-input show-size label="시안 첨부" v-model="draftImage3" accept="image/png, image/jpg, image/jpeg, image/gif" value ref="file" @change="handleFile"></v-file-input>
                  </v-col>
                  <v-col cols="12" v-if="toOrderAttrs.draftImagePath3">
                    <v-container class="align-center">
                      <v-row>
                        <v-img v-bind:src="toOrderAttrs.draftImagePath3" contain class="mx-auto finger" max-width="100%" @click="imageWidth = 100; draftImageDialog3 = true"></v-img>
                        <v-row justify="center">
                          <v-dialog
                              persistent
                              scrollable
                              v-model="draftImageDialog3"
                              max-width="100%"
                              @keydown.esc="closeDraftImageDialog"
                          >
                            <v-card>
                              <v-card-title class="headline">
                                시안 확인
                                <v-spacer></v-spacer>
                                <span style="float:right" class="mr-5">{{ imageWidth }}%</span>
                                <v-btn fab small color="primary" style="float:right" class="mr-3" @click="imagePlus">
                                  <v-icon color="white">mdi-plus</v-icon>
                                </v-btn>
                                <v-btn fab small color="primary" style="float:right" @click="imageMinus">
                                  <v-icon color="white">mdi-minus</v-icon>
                                </v-btn>
                              </v-card-title>
                              <v-card-text>
                                <v-img :src="toOrderAttrs.draftImagePath3" class="mx-auto" :width="imageWidth + '%'" max-width="300%"></v-img>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="green darken-1"
                                    text
                                    @click="draftImageDialog3 = false, imageWidth = 100"
                                >닫기</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-row>
                      </v-row>
                      <v-row>
                        <v-btn outlined color="primary" class="mt-3 ml-9" @click="deleteDraftImage(3)">시안 삭제</v-btn>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>

              <v-row v-if="position != 'edit' && mode != 'copy'" class="ma-5 pa-2">
                <v-col cols="12" v-if="!toOrderAttrs.draftImagePath4" >
                  <v-file-input show-size label="시안 첨부" v-model="draftImage4" accept="image/png, image/jpg, image/jpeg, image/gif" value ref="file" @change="handleFile"></v-file-input>
                </v-col>
                <v-col cols="12" v-if="toOrderAttrs.draftImagePath4">
                  <v-container class="align-center">
                    <v-row>
                      <v-img v-bind:src="toOrderAttrs.draftImagePath4" contain class="mx-auto finger" max-width="100%" @click="imageWidth = 100; draftImageDialog4 = true"></v-img>
                      <v-row justify="center">
                        <v-dialog
                            persistent
                            scrollable
                            v-model="draftImageDialog4"
                            max-width="100%"
                            @keydown.esc="closeDraftImageDialog"
                        >
                          <v-card>
                            <v-card-title class="headline">
                              시안 확인
                              <v-spacer></v-spacer>
                              <span style="float:right" class="mr-5">{{ imageWidth }}%</span>
                              <v-btn fab small color="primary" style="float:right" class="mr-3" @click="imagePlus">
                                <v-icon color="white">mdi-plus</v-icon>
                              </v-btn>
                              <v-btn fab small color="primary" style="float:right" @click="imageMinus">
                                <v-icon color="white">mdi-minus</v-icon>
                              </v-btn>
                            </v-card-title>
                            <v-card-text>
                              <v-img :src="toOrderAttrs.draftImagePath4" class="mx-auto" :width="imageWidth + '%'" max-width="300%"></v-img>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                  color="green darken-1"
                                  text
                                  @click="draftImageDialog4 = false, imageWidth = 100"
                              >닫기</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-row>
                    </v-row>
                    <v-row>
                      <v-btn outlined color="primary" class="mt-3 ml-9" @click="deleteDraftImage(4)">시안 삭제</v-btn>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>

              <v-row v-if="position != 'edit' && mode != 'copy'" class="ma-5 pa-2">
                <v-col cols="12" v-if="!toOrderAttrs.draftImagePath5" class="attachImage">
                  <v-file-input show-size label="시안 첨부" v-model="draftImage5" accept="image/png, image/jpg, image/jpeg, image/gif" value ref="file" @change="handleFile"></v-file-input>
                </v-col>
                <v-col cols="12" v-if="toOrderAttrs.draftImagePath5">
                  <v-container class="align-center">
                    <v-row>
                      <v-img v-bind:src="toOrderAttrs.draftImagePath5" contain class="mx-auto finger" max-width="100%" @click="imageWidth = 100; draftImageDialog5 = true"></v-img>
                      <v-row justify="center">
                        <v-dialog
                            persistent
                            scrollable
                            v-model="draftImageDialog5"
                            max-width="100%"
                            @keydown.esc="closeDraftImageDialog"
                        >
                          <v-card>
                            <v-card-title class="headline">
                              시안 확인
                              <v-spacer></v-spacer>
                              <span style="float:right" class="mr-5">{{ imageWidth }}%</span>
                              <v-btn fab small color="primary" style="float:right" class="mr-3" @click="imagePlus">
                                <v-icon color="white">mdi-plus</v-icon>
                              </v-btn>
                              <v-btn fab small color="primary" style="float:right" @click="imageMinus">
                                <v-icon color="white">mdi-minus</v-icon>
                              </v-btn>
                            </v-card-title>
                            <v-card-text>
                              <v-img :src="toOrderAttrs.draftImagePath5" class="mx-auto" :width="imageWidth + '%'" max-width="300%"></v-img>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                  color="green darken-1"
                                  text
                                  @click="draftImageDialog5 = false, imageWidth = 100"
                              >닫기</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-row>
                    </v-row>
                    <v-row>
                      <v-btn outlined color="primary" class="mt-3 ml-9" @click="deleteDraftImage(5)">시안 삭제</v-btn>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="mode == 'new'" color="blue darken-1" text @click="saveOrder">저장</v-btn>
                <v-btn v-if="type == 'estimate' && position != 'edit'" color="blue darken-1" text @click="saveOrder">작업진행</v-btn>
                <v-btn v-if="mode != 'new' && type == 'estimate'" color="blue darken-1" text @click="saveEstimate">수정</v-btn>
                <v-btn v-if="mode != 'new' && mode != 'copy' && type == 'order'" color="blue darken-1" text @click="saveOrder">수정</v-btn>
                <v-btn v-if="mode == 'copy' && type == 'order'" color="blue darken-1" text @click="saveOrder">복사</v-btn>
                <v-btn color="blue darken-1" text @click="toOrderDialog = false">닫기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import AddClientButton from "@/components/admin/button/AddClientButton";

export default {
    name: 'ToOrderDialog',
    components: {
        AddClientButton
    },
    props: {
        type: {},
        mode: {},
        position: {},
        displayString: {},
        orderId: {},
        isUrgent: {}
    },
    data () {
        return {
            dialogTitle: '진행 내역 입력',
            toOrderClientLoading: false,
            dialogWidth: 1200,
            dialogCols: 6,
            draftImageDialog: false,
            draftImageDialog2: false,
            draftImageDialog3: false,
            draftImageDialog4: false,
            draftImageDialog5: false,
            imageWidth: '100',
            clientList: [],
            clientSearch: null,
            loadedItemText: null,
            //--------------------
            factorySearch: null,
            processLoading: false,
            processList: [],
            processSearch: null,
            process1Loading: false,
            process1List: [],
            process1Search: null,
            process2Loading: false,
            process2List: [],
            process2Search: null,
            process3Loading: false,
            process3List: [],
            process3Search: null,
            process4Loading: false,
            process4List: [],
            process4Search: null,
            process5Loading: false,
            process5List: [],
            process5Search: null,
            process6Loading: false,
            process6List: [],
            process6Search: null,
            process7Loading: false,
            process7List: [],
            process7Search: null,
            //--------------------
            toOrderDialog: false,
            estimateDateDialog: false,
            dueDateDialog: false,
            clientPhone: '',
            orderMethodList: this.$store.getters.getOrderMethodList,
            productCategory: this.$store.getters.getProductCategoryList,
            alarmPeriodList: [
                { text: '1개월', value: '1' },
                { text: '2개월', value: '2' },
                { text: '3개월', value: '3' },
                { text: '4개월', value: '4' },
                { text: '5개월', value: '5' },
                { text: '6개월', value: '6' },
                { text: '7개월', value: '7' },
                { text: '8개월', value: '8' },
                { text: '9개월', value: '9' },
                { text: '10개월', value: '10' },
                { text: '11개월', value: '11' },
                { text: '1년', value: '12' },
                { text: '2년', value: '24' },
                { text: '3년', value: '36' },
            ],
            toOrderAttrs: {
                orderId: this.OrderId,
                clientId: '',
                clientName: '',
                clientPhone: '',
                estimateDate: '',
                dueDate: '',
                category: '',
                title: '',
                address1: '',
                method1: '',
                phone1: '',
                address2: '',
                method2: '',
                phone2: '',
                description: '',
                paperQuantity: '',
                quantity: '',
                process1: '',
                process2: '',
                process3: '',
                process4: '',
                process5: '',
                process6: '',
                process7: '',
                paperType1: '',
                paperType2: '',
                paperSize: '',
                color: '',
                coating: '',
                postProcessing: '',
                subsidiary: '',
                floorPaper: '',
                comment: '',
                commentForProcessing: '',
                alarmCheck: '',
                alarmPeriod: '',
                urgency: '',
                draftImagePath: '',
                draftImagePath2: '',
                draftImagePath3: '',
                draftImagePath4: '',
                draftImagePath5: '',
                isCopy: false
            },
            draftImage: [],
            draftImage2: [],
            draftImage3: [],
            draftImage4: [],
            draftImage5: [],
            groupSetting: null
        }
    },
    watch: {
        toOrderDialog(flag) {
            if(flag == true && this.mode != 'new'){

                let api_url
                if(this.type == 'order'){
                    api_url = this.$store.getters.getApiUrl + '/api/v1/order/getOrder/' + this.orderId
                }else{
                    api_url = this.$store.getters.getApiUrl + '/api/v1/order/getEstimate/' + this.orderId
                }

                if(this.orderId > 0){

                    return axios({
                        method: 'GET',
                        headers: {
                            'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                        },
                        url: api_url,
                        timeout: this.$store.getters.getApiRequestTimeLimit
                    })
                    .then(response => {

                        const res = response.data

                        let clientBlock = res.clientName

                        if(res.clientBrand){
                          clientBlock += '(' + res.clientBrand + ')'
                        }

                        if(res.clientPhone){
                          clientBlock += ' ' + res.clientPhone
                        }

                        this.clientList = [{ text: clientBlock, value: res.clientId }]

                        if(res.process1Name){
                          this.process1List = [{ text: res.process1Name, value: res.process1 }]
                        }

                        if(res.process2Name){
                          this.process2List = [{ text: res.process2Name, value: res.process2 }]
                        }

                        if(res.process3Name){
                          this.process3List = [{ text: res.process3Name, value: res.process3 }]
                        }

                        if(res.process4Name){
                          this.process4List = [{ text: res.process4Name, value: res.process4 }]
                        }

                        if(res.process5Name){
                          this.process5List = [{ text: res.process5Name, value: res.process5 }]
                        }

                        if(res.process6Name){
                          this.process6List = [{ text: res.process6Name, value: res.process6 }]
                        }

                        if(res.process7Name){
                          this.process7List = [{ text: res.process7Name, value: res.process7 }]
                        }

                        res.estimateDate = this.$day(res.estimateDate).format('YYYY-MM-DD')
                        res.dueDate = this.$day(res.dueDate).format('YYYY-MM-DD')

                        this.toOrderAttrs = res

                        if(res.alarmPeriod > 0){
                            this.toOrderAttrs.alarmCheck = true
                            this.toOrderAttrs.alarmPeriod = res.alarmPeriod
                        }

                        this.toOrderClientLoading = false

                    })

                }else{

                  //clear attrs
                  this.clearToOrderAttrs()

                  alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                  return false

                }

            }else{

              //clear attrs
              this.clearToOrderAttrs()

              //to false draftImageDialog whether this is opened or not
              this.draftImageDialog = false

            }
        },
        async clientSearch (val) {
            val && val !== this.toOrderAttrs.clientId && await this.queryClientSelections(val)
            this.toOrderClientLoading = false
        },
        process1Search (val) {
            val && this.queryFactory1Selections(val)
        },
        process2Search (val) {
            val && this.queryFactory2Selections(val)
        },
        process3Search (val) {
            val && this.queryFactory3Selections(val)
        },
        process4Search (val) {
            val && this.queryFactory4Selections(val)
        },
        process5Search (val) {
            val && this.queryFactory5Selections(val)
        },
        process6Search (val) {
            val && this.queryFactory6Selections(val)
        },
        process7Search (val) {
            val && this.queryFactory7Selections(val)
        },
    },
    methods: {
        imagePlus: function() {
            if(this.imageWidth >= 300){
                return false
            }
            this.imageWidth = parseInt(this.imageWidth) + 10
        },
        imageMinus: function() {
            if(this.imageWidth <= 50){
                return false
            }
            this.imageWidth = parseInt(this.imageWidth) - 10
        },
        closeDraftImageDialog: function(e) {
            console.log(e)
            this.draftImageDialog = false
        },
        handleFile() {
            const fileCount = (this.$refs.file && this.$refs.file.files) ? this.$refs.file.files.length : 0
            if(fileCount > 0){
                for(let i = 0; i < fileCount; i++){
                    this.draftImage.push(this.$refs.file.files[i])
                }
            }
        },
        saveEstimate() {

            if(this.toOrderAttrs.estimateDate == this.toOrderAttrs.dueDate){
                if(!confirm('작성일과 납품 예정일이 같습니다.\n의도하신건가요?')){
                    return false
                }
            }

            if(!this.toOrderAttrs.clientId){
                alert('거래처를 입력해주세요.')
                return false
            }

            if(!this.toOrderAttrs.category){
                alert('품목을 선택해주세요.')
                return false;
            }

            if(!this.toOrderAttrs.title){
                alert('작업명을 선택해주세요.')
                return false;
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/estimate',
                data: {
                    orderId: this.orderId,
                    clientId: this.toOrderAttrs.clientId,
                    estimateDate: this.toOrderAttrs.estimateDate,
                    dueDate: this.toOrderAttrs.dueDate,
                    category: this.toOrderAttrs.category,
                    title: this.toOrderAttrs.title,
                    address1: this.toOrderAttrs.address1,
                    method1: this.toOrderAttrs.method1,
                    phone1: this.toOrderAttrs.phone1,
                    address2: this.toOrderAttrs.address2,
                    method2: this.toOrderAttrs.method2,
                    phone2: this.toOrderAttrs.phone2,
                    comment: this.toOrderAttrs.comment
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.status && response.data.status == '0000'){

                    //estimate 수정 성공 시
                    alert('정상적으로 수정되었습니다.')
                    this.toOrderDialog = false
                    location.reload()

                }else{

                    alert(response.data.message)
                    return false

                }

            })
            .catch((error) => {

                if(error && error.name == "InvalidJwtToken"){

                    //JWT 토큰이 정확하지 않을 시
                    alert('인증 토큰이 유효하지 않습니다.')
                    return false

                }else{

                    //저장 실패 시
                    alert('진행 예정 사항 저장에 실패했습니다.\n다시 시도해주세요.')

                }

            })

        },
        saveOrder() {

            if(this.toOrderAttrs.estimateDate == this.toOrderAttrs.dueDate){
                if(!confirm('작성일과 납품예정일이 같습니다.\n의도하신건가요?')){
                    return false
                }
            }

            if(!this.toOrderAttrs.clientId){
                alert('거래처를 입력해주세요.')
                return false
            }

            if(!this.toOrderAttrs.category){
                alert('품목을 선택해주세요.')
                return false;
            }

            if(!this.toOrderAttrs.title){
                alert('작업명을 입력해주세요.')
                return false;
            }

            //Copy 모드일 경우 isCopy flag on
            if(this.mode == 'copy'){
                this.toOrderAttrs.isCopy = true
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/order',
                data: this.toOrderAttrs,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(async response => {

                if(response.data != null && response.data.status && response.data.status == '0000'){

                    //첨부 이미지 있을 시 업로드
                    if(this.draftImage != '') {
                        await this.uploadDraftImage(response.data.orderId, 1)
                    }

                    if(this.draftImage2 != '') {
                      await this.uploadDraftImage(response.data.orderId, 2)
                    }

                    if(this.draftImage3 != '') {
                      await this.uploadDraftImage(response.data.orderId, 3)
                    }

                    if(this.draftImage4 != '') {
                      await this.uploadDraftImage(response.data.orderId, 4)
                    }

                    if(this.draftImage5 != '') {
                      await this.uploadDraftImage(response.data.orderId, 5)
                    }

                    //order 저장 성공 시
                    alert('정상적으로 저장되었습니다.')
                    this.toOrderDialog = false
                    location.reload()

                }

            })
            .catch((error) => {

                if(error && error.name == "InvalidJwtToken"){

                    //JWT 토큰이 정확하지 않을 시
                    alert('인증 토큰이 유효하지 않습니다.')
                    return false

                }else{

                    //저장 실패 시
                    alert('진행 내역 저장에 실패했습니다.\n다시 시도해주세요.')

                }

            })

        },
        uploadDraftImage(orderId, imageOrder) {

            let formData = new FormData()
            switch(imageOrder){
              case 1:
                formData.append('draftImage', this.draftImage)
                break
              case 2:
                formData.append('draftImage', this.draftImage2)
                break
              case 3:
                formData.append('draftImage', this.draftImage3)
                break
              case 4:
                formData.append('draftImage', this.draftImage4)
                break
              case 5:
                formData.append('draftImage', this.draftImage5)
                break
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken,
                    'Content-Type': 'multipart/form-data'
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/uploadDraftImage/' + orderId + '/' + imageOrder,
                data: formData,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    if(response.data != null && response.data.status && response.data.status == '0000'){

                        //image 저장 성공 시

                    }else{

                        alert(response.data.message)
                        return false

                    }

                })
                .catch((error) => {

                    if(error && error.name == "InvalidJwtToken"){

                        //JWT 토큰이 정확하지 않을 시
                        alert('인증 토큰이 유효하지 않습니다.')
                        return false

                    }else{

                        //저장 실패 시
                        alert('[' + imageOrder + '] 시안 업로드에 실패했습니다.\n다시 시도해주세요.')

                    }

                })

        },
        deleteDraftImage(imageOrder) {

            if(!confirm('정말 삭제하시겠습니까?')){
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/deleteDraftImage/' + this.toOrderAttrs.orderId + '/' + imageOrder,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null){

                    const res = response.data

                    if(res.message){
                      alert(res.message)
                    }

                    if(res.status == '0000'){
                        switch(imageOrder){
                            case 1:
                              this.toOrderAttrs.draftImagePath = null
                              break
                            case 2:
                              this.toOrderAttrs.draftImagePath2 = null
                              break
                            case 3:
                              this.toOrderAttrs.draftImagePath3 = null
                              break
                            case 4:
                              this.toOrderAttrs.draftImagePath4 = null
                              break
                            case 5:
                              this.toOrderAttrs.draftImagePath5 = null
                              break
                        }

                    }else{
                        return false
                    }

                }

            })
            .catch(() => {

                alert('파일 삭제에 실패했습니다.')

            })

        },
        queryClientSelections (v) {

            this.toOrderClientLoading = true

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/search',
                data: {
                    clientType: 'general',
                    searchString: v
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.length > 0){

                    this.clientList = []
                    this.phoneNumberList = []

                    if(response.data && response.data[0].value > 0){
                        this.clientList = response.data

                        // response.data.forEach(function(item){
                        //     console.log(item.phone)
                        //     this.phoneNumberList[item.id].push(item.phone)
                        // })
                    }

                    this.toOrderClientLoading = false

                }

            })
            .catch(() => {

                this.toOrderClientLoading = false

            })

        },
        queryFactory1Selections (v) {

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/search',
                data: {
                    clientType: 'factory',
                    searchString: v
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    const res = response.data

                    if (res != null && res.length > 0) {

                        this.process1List = []

                        if (res && res[0].value > 0) {
                            this.process1List = res
                        }

                    }

                    this.process1Loading = false

                })

        },
        queryFactory2Selections (v) {

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/search',
                data: {
                    clientType: 'factory',
                    searchString: v
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    const res = response.data

                    if (res != null && res.length > 0) {

                        this.process2List = []

                        if (res && res[0].value > 0) {
                            this.process2List = res
                        }

                    }

                    this.process2Loading = false

                })

        },
        queryFactory3Selections (v) {

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/search',
                data: {
                    clientType: 'factory',
                    searchString: v
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    const res = response.data

                    if (res != null && res.length > 0) {

                        this.process3List = []

                        if (res && res[0].value > 0) {
                            this.process3List = res
                        }

                    }

                    this.process3Loading = false

                })

        },
        queryFactory4Selections (v) {

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/search',
                data: {
                    clientType: 'factory',
                    searchString: v
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    const res = response.data

                    if (res != null && res.length > 0) {

                        this.process4List = []

                        if (res && res[0].value > 0) {
                            this.process4List = res
                        }

                    }

                    this.process4Loading = false

                })

        },
        queryFactory5Selections (v) {

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/search',
                data: {
                    clientType: 'factory',
                    searchString: v
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    const res = response.data

                    if (res != null && res.length > 0) {

                        this.process5List = []

                        if (res && res[0].value > 0) {
                            this.process5List = res
                        }

                    }

                    this.process5Loading = false

                })

        },
        queryFactory6Selections (v) {

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/search',
                data: {
                    clientType: 'factory',
                    searchString: v
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    const res = response.data

                    if (res != null && res.length > 0) {

                        this.process6List = []

                        if (res && res[0].value > 0) {
                            this.process6List = res
                        }

                    }

                    this.process6Loading = false

                })

        },
        queryFactory7Selections (v) {

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/search',
                data: {
                    clientType: 'factory',
                    searchString: v
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    const res = response.data

                    if (res != null && res.length > 0) {

                        this.process7List = []

                        if (res && res[0].value > 0) {
                            this.process7List = res
                        }

                    }

                    this.process7Loading = false

                })

        },
        setClientPhoneNumber(value) {

            //clientId 업데이트
            this.toOrderAttrs.clientId = value

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/getPhoneNumber',
                data: {
                    id: value,
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.phoneNumber != ''){

                    this.clientPhone = response.data.phoneNumber
                    this.toOrderClientLoading = false

                }

            })

        },
        clearToOrderAttrs() {

            if(this.mode != 'new'){

                this.toOrderAttrs = {
                    orderId: '',
                    clientId: '',
                    clientName: '',
                    clientPhone: '',
                    estimateDate: new Date().toISOString().substr(0, 10),
                    dueDate: new Date().toISOString().substr(0, 10),
                    category: '',
                    title: '',
                    address1: '',
                    method1: '',
                    phone1: '',
                    address2: '',
                    method2: '',
                    phone2: '',
                    comment: '',
                }

            }else{

                this.toOrderAttrs = {
                    orderId: '',
                    clientId: '',
                    clientName: '',
                    clientPhone: '',
                    estimateDate: new Date().toISOString().substr(0, 10),
                    dueDate: new Date().toISOString().substr(0, 10),
                    category: '',
                    title: '',
                    address1: '',
                    method1: '',
                    phone1: '',
                    address2: '',
                    method2: '',
                    phone2: '',
                    description: '',
                    paperQuantity: '',
                    quantity: '',
                    process1: '',
                    process2: '',
                    process3: '',
                    process4: '',
                    process5: '',
                    process6: '',
                    process7: '',
                    paperType1: '',
                    paperType2: '',
                    paperSize: '',
                    color: '',
                    coating: '',
                    postProcessing: '',
                    subsidiary: '',
                    floorPaper: '',
                    comment: '',
                    commentForProcessing: '',
                    alarmCheck: '',
                    alarmPeriod: '',
                    urgency: '',
                    draftImagePath: '',
                    isCopy: false
                }

            }

        },
        checkDuplicate(original, val) {

            if(val == null || val == 'undefined') {

                if(original == 1){
                    this.toOrderAttrs.process1 = null
                    this.toOrderAttrs.process2 = null
                    this.toOrderAttrs.process3 = null
                    this.toOrderAttrs.process4 = null
                    this.toOrderAttrs.process5 = null
                    this.toOrderAttrs.process6 = null
                    this.toOrderAttrs.process7 = null
                }else if(original == 2){
                    this.toOrderAttrs.process2 = null
                    this.toOrderAttrs.process3 = null
                    this.toOrderAttrs.process4 = null
                    this.toOrderAttrs.process5 = null
                    this.toOrderAttrs.process6 = null
                    this.toOrderAttrs.process7 = null
                }else if(original == 3){
                    this.toOrderAttrs.process3 = null
                    this.toOrderAttrs.process4 = null
                    this.toOrderAttrs.process5 = null
                    this.toOrderAttrs.process6 = null
                    this.toOrderAttrs.process7 = null
                }else if(original == 4){
                    this.toOrderAttrs.process4 = null
                    this.toOrderAttrs.process5 = null
                    this.toOrderAttrs.process6 = null
                    this.toOrderAttrs.process7 = null
                }else if(original == 5){
                    this.toOrderAttrs.process5 = null
                    this.toOrderAttrs.process6 = null
                    this.toOrderAttrs.process7 = null
                }else if(original == 6){
                    this.toOrderAttrs.process6 = null
                    this.toOrderAttrs.process7 = null
                }else if(original == 7){
                    this.toOrderAttrs.process7 = null
                }

                // eval('if(this.toOrderAttrs.process' + original + ' == \'undefined\'){')
                //     for (let i = 7; i > original; i--) {
                //         setTimeout(function(){
                //         eval('this.toOrderAttrs.process' + original + ' = null')
                //         eval('this.process' + original + 'List = []')
                //         eval('this.process' + original + 'Search = null')
                //         }.bind(this), 200)
                //     }
                // eval('}')

                // eval('if(this.toOrderAttrs.process' + original + ' == \'undefined\'){'
                //  + 'for (let i = 7; i > original; i--) {'
                //  +   'setTimeout(function(){'
                //  +      'this.toOrderAttrs.process' + original + ' = null'
                //  +      'this.process' + original + 'List = []'
                //  +      'this.process' + original + 'Search = null'
                //  +   '}, 200)'
                //  + '}'
                //  + '}')

                // eval('console.log(this.toOrderAttrs)')
                //
                // // console.log(this.toOrderAttrs)
                // console.log('오리기날 : ' + original)
                // console.log('아스날 : ' + val)
                // console.log(this.process1Search)
                // console.log(this.process2Search)
                // console.log(this.process3Search)
                // console.log(this.process4Search)
                // console.log(this.process5Search)
                // console.log(this.process6Search)
                // console.log(this.process7Search)
                //
                // setTimeout(function(){
                //     console.log(this.toOrderAttrs)
                // }.bind(this), 1000)

            }

            if(val != null && original != 1 && val == this.toOrderAttrs.process1){
                alert('1번째 프로세스와 동일합니다.')
                return false
            }else if(val != null && original != 2 && val == this.toOrderAttrs.process2){
                alert('2번째 프로세스와 동일합니다.')
                return false
            }else if(val != null && original != 3 && val == this.toOrderAttrs.process3){
                alert('3번째 프로세스와 동일합니다.')
                return false
            }else if(val != null && original != 4 && val == this.toOrderAttrs.process4){
                alert('4번째 프로세스와 동일합니다.')
                return false
            }else if(val != null && original != 5 && val == this.toOrderAttrs.process5){
                alert('5번째 프로세스와 동일합니다.')
                return false
            }else if(val != null && original != 6 && val == this.toOrderAttrs.process6){
                alert('6번째 프로세스와 동일합니다.')
                return false
            }else if(val != null && original != 7 && val == this.toOrderAttrs.process7){
                alert('7번째 프로세스와 동일합니다.')
                return false
            }
        },
        checkDuplicate1(val) {
            this.checkDuplicate(1, val)
        },
        checkDuplicate2(val) {
            this.checkDuplicate(2, val)
        },
        checkDuplicate3(val) {
            this.checkDuplicate(3, val)
        },
        checkDuplicate4(val) {
            this.checkDuplicate(4, val)
        },
        checkDuplicate5(val) {
            this.checkDuplicate(5, val)
        },
        checkDuplicate6(val) {
            this.checkDuplicate(6, val)
        },
        checkDuplicate7(val) {
            this.checkDuplicate(7, val)
        },
    },
    created: function() {
        if(this.position == 'edit'){
            this.dialogTitle = '진행 예정 수정'
            this.dialogWidth = 600
            this.dialogCols = 12
        }

        if(this.$store.getters.getAccessToken != null){
            this.groupSetting = this.$store.getters.getGroupSetting
        }
    }
}
</script>

<style scoped>
    .finger { cursor: pointer; }

    .attachImage {
        height: 40px;
    }

    .v-application .pa-2 {
      padding: 0 8px !important;
    }

    .v-application .ma-5 {
      margin: 0 20px !important;
    }
</style>